interface Series {
  label: string;
  color: string;
  values: number[];
}

interface Props {
  labels: string[];
  series: Series[];
  height?: number;
  formatY?: (v: number) => string;
}

export function BarChart({ labels, series, height = 220, formatY = (v) => v.toLocaleString() }: Props) {
  const max = Math.max(1, ...series.flatMap((s) => s.values));
  const groupWidth = 100 / labels.length;
  const barWidth = groupWidth / (series.length + 0.5);

  return (
    <div className="w-full">
      <svg viewBox={`0 0 100 ${height}`} preserveAspectRatio="none" className="w-full" style={{ height }}>
        {labels.map((_, i) => (
          <line
            key={i}
            x1={0}
            y1={(height / 4) * i}
            x2={100}
            y2={(height / 4) * i}
            stroke="#e2e8f0"
            strokeWidth={0.2}
          />
        ))}
        {labels.map((_, lIdx) => (
          <g key={lIdx}>
            {series.map((s, sIdx) => {
              const v = s.values[lIdx] ?? 0;
              const h = (v / max) * (height - 30);
              const x = lIdx * groupWidth + sIdx * barWidth + 1;
              const y = height - 20 - h;
              return (
                <rect
                  key={sIdx}
                  x={x}
                  y={y}
                  width={barWidth - 0.5}
                  height={h}
                  fill={s.color}
                  rx={0.5}
                >
                  <title>{`${labels[lIdx]} · ${s.label}: ${formatY(v)}`}</title>
                </rect>
              );
            })}
          </g>
        ))}
      </svg>
      <div className="flex justify-between text-xs text-slate-500 px-1">
        {labels.map((l) => (
          <span key={l}>{l}</span>
        ))}
      </div>
      <div className="flex gap-4 mt-2 text-xs">
        {series.map((s) => (
          <div key={s.label} className="flex items-center gap-1">
            <span className="inline-block w-3 h-3 rounded" style={{ background: s.color }} />
            <span>{s.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
